import type { SagaIterator } from "redux-saga";
import { call, fork, put, take } from "redux-saga/effects";
import { getType } from "typesafe-actions";

import * as featureApi from "@/shop/api/personalized/features";

import * as PersonalizedAreaActions from "./actions";
import originalSupplySaga from "./originalSupply/saga";
import type { IShopFeatures } from "../../types/personalized";

function* detectFeatures(): SagaIterator {
  try {
    yield put(PersonalizedAreaActions.detectFeaturesStart());
    const features = (yield call(featureApi.detectFeatures)) as IShopFeatures;
    yield put(PersonalizedAreaActions.detectFeaturesSuccess(features));
  } catch (err) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    yield put(PersonalizedAreaActions.detectFeaturesFail(err));
  }
}

function* detectFeaturesOnce(): SagaIterator {
  yield take(getType(PersonalizedAreaActions.detectFeatures));
  yield fork(detectFeatures);
}

export default function* personalizedAreaSaga(): SagaIterator {
  yield fork(detectFeaturesOnce);
  yield fork(originalSupplySaga);
}
